import React from "react";
import { useI18n } from "../i18n";
import { useSeo } from "../hooks/useSeo";
import { pathFor } from "../config/site";
import { TIMELINE, IMAGES } from "../data/structure";
import { webpageLd, articleLd, breadcrumbLd, personLd } from "../lib/jsonld";
import PageHero from "../components/PageHero";
import { Section, SectionHeading } from "../components/Section";
import Timeline from "../components/Timeline";
import WorksHighlights from "../components/WorksHighlights";
import OfficialLinks from "../components/OfficialLinks";

export default function MusicPage({ pageKey }) {
  const { lang, d } = useI18n();
  const meta = d.meta.music;
  const items = TIMELINE.filter((t) => t.category === "music");

  useSeo({
    pageKey,
    title: meta.title,
    description: meta.description,
    jsonLd: [
      webpageLd({ lang, pageKey, title: meta.title, description: meta.description }),
      articleLd({ lang, pageKey, headline: d.pillars.music.title, description: meta.description }),
      personLd(),
      breadcrumbLd([
        { name: d.ui.nav.home, path: pathFor(lang, "home") },
        { name: d.ui.nav.music, path: pathFor(lang, "music") },
      ]),
    ],
  });

  return (
    <>
      <PageHero testid="music-hero" kicker={d.pillars.music.title} title={d.meta.music.title.split(" |")[0]} intro={d.pages.music.intro} image={IMAGES.stageLights} />
      <WorksHighlights only="music" />
      <Section testid="music-timeline">
        <SectionHeading kicker={d.timelineSection.kicker} heading={d.worksSection.music} />
        <div className="mt-14"><Timeline items={items} /></div>
      </Section>
      <OfficialLinks />
    </>
  );
}
